import Image from "next/image";
import Link from "next/link";

import SectionContainer from "~/components/SectionContainer";
import { CPT_PROGRAMS_PAGE } from "~/lib/cpt-programs-page";
import NccaAccreditedProgramMark from "~/pages/exam-portal/components/NccaAccreditedProgramMark";

const CptTwoWays = () => {
	return (
		<SectionContainer className="flex max-w-5xl flex-col gap-8 border-b">
			<div className="mx-auto flex max-w-3xl flex-col gap-3 text-center">
				<h2 className="font-bold text-2xl sm:text-3xl lg:text-4xl">
					Two ways to become a CPT. Most people do both.
				</h2>
				<p className="text-base sm:text-lg lg:text-xl">
					The Brookbush Institute offers a certificate-based educational program
					and a professional certification credential. They&apos;re different
					products with different purposes — and together they&apos;re the most
					efficient path we know to a certified, employable, and truly
					well-educated personal trainer.
				</p>
			</div>

			<div className="grid gap-8 lg:grid-cols-2">
				<article className="flex flex-col gap-4 rounded-2xl border bg-slate-50 p-5 sm:p-6 dark:bg-slate-800/60">
					<div className="flex items-start gap-3">
						<div
							className="relative shrink-0 overflow-hidden rounded-md bg-white shadow-sm"
							style={{ width: 120, height: 120 }}
						>
							<Image
								src={CPT_PROGRAMS_PAGE.biShieldSrc}
								alt="Brookbush Institute shield"
								width={120}
								height={120}
								className="h-full w-full object-contain p-1"
							/>
						</div>
						<h3 className="font-semibold text-xl sm:text-2xl">
							Certified Personal Trainer Certificate (BI-CPT) — included in
							membership
						</h3>
					</div>
					<p>
						Our education-based credential, awarded by the Brookbush Institute
						on completion of its training program.
					</p>
					<ul className="ml-5 list-disc space-y-2">
						<li>
							A structured, evidence-based, client-centered approach to personal
							training, built on systematic reviews of the research
						</li>
						<li>
							Self-paced and modular, with small exams after each course and a
							credit system that tracks your progress automatically — fifty
							credits and you&apos;ve earned it
						</li>
						<li>
							Delivered on the Institute&apos;s online platform, desktop and
							mobile
						</li>
						<li>
							Included with an active membership to BrookbushInstitute.com
						</li>
					</ul>
					<p>
						Accepted for employment by Equinox, Life Time, and GoodLife Fitness.
						It&apos;s the credential we recommend you start with.
					</p>
					<Link
						href={CPT_PROGRAMS_PAGE.biCptHref}
						className="mt-auto inline-flex max-w-max items-center rounded-xl bg-gradient-to-r from-sky-500 to-sky-700 px-4 py-2.5 font-medium text-white hover:brightness-95"
					>
						Start the BI-CPT →
					</Link>
				</article>

				<article className="flex flex-col gap-4 rounded-2xl border bg-slate-50 p-5 sm:p-6 dark:bg-slate-800/60">
					<div className="flex items-start gap-3">
						<NccaAccreditedProgramMark size="md" />
						<h3 className="font-semibold text-xl sm:text-2xl">
							Certified Personal Trainer (CPT) Certification — NCCA-accredited
						</h3>
					</div>
					<p>
						A professional certification credential, earned by passing a
						standalone, proctored examination.
					</p>
					<ul className="ml-5 list-disc space-y-2">
						<li>
							Accredited by the National Commission for Certifying Agencies
							(NCCA), September 22, 2026
						</li>
						<li>
							110 multiple-choice questions, delivered online by live remote
							proctoring or at an authorized testing center
						</li>
						<li>
							Developed using nationally recognized certification best practices
							— job task analysis, secure exam development, psychometric
							analysis, and formal standard-setting — and governed by an
							independent Certification Governing Board
						</li>
						<li>Awarded solely on examination performance</li>
					</ul>
					<p>
						If your employer requires an NCCA-accredited certification, this is
						the credential built for that.
					</p>
					<Link
						href={CPT_PROGRAMS_PAGE.examPortalHref}
						className="mt-auto inline-flex max-w-max items-center rounded-xl bg-gradient-to-r from-sky-500 to-sky-700 px-4 py-2.5 font-medium text-white hover:brightness-95"
					>
						Register for the exam →
					</Link>
				</article>
			</div>

			<p className="mx-auto max-w-3xl text-center text-base sm:text-lg">
				<strong>Separate and independent.</strong> The BI-CPT Certificate and
				the CPT Certification are distinct. No Brookbush Institute course or
				membership is required to sit for the exam; completing Institute courses
				provides no credit, points, or scoring advantage on it; and the exam fee
				is separate from membership. Candidates may prepare with any resources
				they choose.
			</p>
		</SectionContainer>
	);
};

export default CptTwoWays;
